import { NavigationFlow } from "@b2bportal/core-utilities";
import type { CarSteps } from "./CarNavigationFlowProvider";

const useGoToNextStep = (currentStep: CarSteps) => {
  return NavigationFlow.useGoToNextStep<CarSteps>(currentStep);
};

const useGoToStep = () => {
  return NavigationFlow.useGoToStep<CarSteps>();
};

export const CarNavigationFlow = {
  useGoToNextStep,
  useGoToStep,
};
